import { type PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

type Props = {
  className?: string;
};

const Layout = ({ children, className }: PropsWithChildren<Props>) => {
  return (
    <div className={cn('flex h-screen w-full flex-col overflow-hidden bg-gray-100', className)}>
      {children}
    </div>
  );
};

const Content = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <main className={cn('flex min-h-0 flex-1 flex-col', className)}>{children}</main>;
};

Layout.Content = Content;

export default Layout;
